import React, { Component } from 'react';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import Constants from '../../../../definitions/constants';
import { FormattedMessage } from 'react-intl';

import TextBox from './textBox';

class CommandTextBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preCommandText: ""
    };
  }
  
  handleOnChange = async (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.setState({
      preCommandText: value
    });
  };

  handleOnCommand = (event) => {
    if(this.props.onClickCommand) {
      this.props.onClickCommand({
        currentTarget: {
          dataset: {
            path: this.props["data-path"],
          },
          value: this.state.preCommandText
        }
      });
    }
  };

  handleOnClear = (event) => {
    if(this.props.onClickCommand) {
      this.props.onClickCommand({
        currentTarget: {
          dataset: {
            path: this.props["data-path"],
          },
          value: ""
        }
      });
    }
    this.setState({
      preCommandText: ""
    });
  };
  
  render() {
    const {
      className,
      id,
      labelLocale,
      disabled,
      dataType,
      value,
      onClickCommand,
    } = this.props;

    return (
      <div className={"custom-input command-textbox matter-textfield-outlined" + (className ? " " + className : "") }>
        <TextBox
          className={(value && !disabled) ? "light-disabled" : ""}
          styleType={Constants.interface.inputs.styleType.OUTLINED}
          type={Constants.interface.inputs.type.TEXT}
          value={value ? value : this.state.preCommandText}
          disabled={value ? true : disabled}
          onChange={this.handleOnChange}
          onKeyEnter={this.handleOnCommand}
          dataType={dataType}
          labelLocale={labelLocale}
        />
        {value ? (
          <i 
            className="fas fa-times-circle"
            onClick={this.handleOnClear}
          />
        ) : null }
        {(!value && this.state.preCommandText) ? (
          <i 
            className="fas fa-search"
            onClick={this.handleOnCommand}
          />
        ) : null }
      </div>
    );
  }
}

export default CommandTextBox;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/commandTextBox.jsx